/**
 * This file contains generic methods to make http requests
 */

import axios from 'axios'
import { TOKEN_NAME } from './constants'
import Cookies from 'js-cookie'

export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 180000,
  contentType: 'application/json',
  headers: {
    'Content-Type': 'application/json'
  }
})

export function interceptorsConfig() {
  axiosInstance.interceptors.request.use(
    function (config) {
      return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      return Promise.reject(error)
    }
  )
}

let token = getCookie(TOKEN_NAME)
if (token) {
  axiosInstance['defaults']['headers']['Authorization'] = 'Token ' + token
}

export function setHeaderAuthorization(tokenString) {
  axiosInstance['defaults']['headers']['Authorization'] = 'Token ' + tokenString
}

export function deleteHeaderAuthorization() {
  deleteCookie(TOKEN_NAME)
  delete axiosInstance.defaults.headers['Authorization']
}

export function get(url, params) {
  return axiosInstance.get(url, { params: params })
}

export function post(url, params) {
  let bodyFormData = new FormData()
  if (params) {
    for (let param in params) {
      bodyFormData.append(param, params[param])
    }
  }
  return axiosInstance.post(url, bodyFormData)
}
export function postJson(url, params) {
  return axiosInstance.post(url, params)
}
// [object Object],[object Object]
export function postList(url, params) {
  let bodyFormData = new FormData()
  if (params) {
    for (let param in params) {
      if (param.split('_', 1)[0] !== 'list') {
        bodyFormData.append(param, params[param])
      } else {
        bodyFormData.append(param, JSON.stringify(params[param]))
      }
    }
  }
  return axiosInstance.post(url, bodyFormData)
}

export function patch(url, params) {
  let bodyFormData = new FormData()
  if (params) {
    for (let param in params) {
      bodyFormData.append(param, params[param])
    }
  }
  return axiosInstance.patch(url, bodyFormData)
}
export function patchJson(url, params) {
  return axiosInstance.patch(url, params)
}

export function deleteMethod(url, params) {
  let bodyFormData = new FormData()
  if (params) {
    for (let param in params) {
      bodyFormData.append(param, params[param])
    }
  }
  return axiosInstance.delete(url, bodyFormData)
}

export function makeUrl(url, params) {
  if (params) {
    for (let param in params) {
      url = url.replace('{' + param + '}', params[param])
    }
  }
  return window.location.origin + '' + url
}

export function formatUrl(url, params) {
  if (params) {
    for (let param in params) {
      url = url.replace('{' + param + '}', params[param])
    }
  }
  return url
}

export function deleteCookie(cname) {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
}

export function setCookie(cname, cvalue, exdays) {
  Cookies.set(cname, cvalue, { expires: exdays, path: '/' })
}

export function getCookie(cname) {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/request.js